/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LasgroTask_notification_tagCollection } from '../models/lasgro-task-_notification-_tag-collection';
import { LasgroTask_notification_tag } from '../models/lasgro-task-_notification-_tag';
@Injectable({
  providedIn: 'root',
})
class TaskNotificationTagService extends __BaseService {
  static readonly taskNotificationTagListPath = '/workflows/task_notification_tags';
  static readonly taskNotificationTagShowPath = '/workflows/task_notification_tags/{taskNotificationTagID}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list task_notification_tag
   *
   * List all of the task notifications tags
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  taskNotificationTagListResponse(): __Observable<__StrictHttpResponse<LasgroTask_notification_tagCollection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/workflows/task_notification_tags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LasgroTask_notification_tagCollection>;
      })
    );
  }
  /**
   * list task_notification_tag
   *
   * List all of the task notifications tags
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  taskNotificationTagList(): __Observable<LasgroTask_notification_tagCollection> {
    return this.taskNotificationTagListResponse().pipe(
      __map(_r => _r.body as LasgroTask_notification_tagCollection)
    );
  }

  /**
   * show task_notification_tag
   *
   * Details of a task notification tag
   *
   * Required security scopes:
   *   * `api:access`
   * @param taskNotificationTagID undefined
   * @return OK
   */
  taskNotificationTagShowResponse(taskNotificationTagID: string): __Observable<__StrictHttpResponse<LasgroTask_notification_tag>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/workflows/task_notification_tags/${encodeURIComponent(String(taskNotificationTagID))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LasgroTask_notification_tag>;
      })
    );
  }
  /**
   * show task_notification_tag
   *
   * Details of a task notification tag
   *
   * Required security scopes:
   *   * `api:access`
   * @param taskNotificationTagID undefined
   * @return OK
   */
  taskNotificationTagShow(taskNotificationTagID: string): __Observable<LasgroTask_notification_tag> {
    return this.taskNotificationTagShowResponse(taskNotificationTagID).pipe(
      __map(_r => _r.body as LasgroTask_notification_tag)
    );
  }
}

module TaskNotificationTagService {
}

export { TaskNotificationTagService }
